import { FC, PropsWithChildren } from 'react';

const MetaTagsFormWrapper: FC<PropsWithChildren & { label?: string }> = ({ label, children }) => {
  return (
    <div className={'bg-gray-100 rounded-2xl px-4 py-6 mb-[20px]'}>
      {label && <div className={'font-semibold mb-[20px]'}>{label}</div>}
      {children}
    </div>
  );
};

export default MetaTagsFormWrapper;
